// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"79410b2413e98c31","3241":"984ba5faec13f83f","9155":"984ba5faec13f83f","9935":"e9f5e5cb0e2ac41d"}[chunkId] + ".css";
};